


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"



window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.secure-ah-retrieve.shared-components/ah-acct-ssn-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-ah-retrieve-ah-acct-ssn-shared-component-es6" */ "@sparta.secure-ah-retrieve.shared-components/ah-acct-ssn-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-change-passcode-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-change-passcode-shared-component-es6" */ "@sparta.login.shared-components/ah-change-passcode-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.stepup.shared-components/ah-authcode-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/stepup-ah-authcode-shared-component-es6" */ "@sparta.stepup.shared-components/ah-authcode-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-security-preference-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-security-preference-shared-component-es6" */ "@sparta.login.shared-components/ah-security-preference-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-ah-retrieve.shared-components/ah-retrieve-no-ssn-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-ah-retrieve-ah-retrieve-no-ssn-shared-component-es6" */ "@sparta.secure-ah-retrieve.shared-components/ah-retrieve-no-ssn-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-spinner",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-spinner-es6" */ "@sparta.global.shared-components/spa-vue-spinner/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-messaging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-messaging-es6" */ "@sparta.global.shared-components/spa-vue-messaging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-button",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-button-es6" */ "@sparta.global.shared-components/spa-vue-button/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-badging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-badging-es6" */ "@sparta.global.shared-components/spa-vue-badging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-svg",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-svg-es6" */ "@sparta.global.shared-components/spa-vue-svg/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-ah-retrieve.shared-components/ah-retrieve-atvo-debit-card-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-ah-retrieve-ah-retrieve-atvo-debit-card-shared-component-es6" */ "@sparta.secure-ah-retrieve.shared-components/ah-retrieve-atvo-debit-card-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-ah-retrieve.shared-components/ah-retrieve-atvo-credit-card-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-ah-retrieve-ah-retrieve-atvo-credit-card-shared-component-es6" */ "@sparta.secure-ah-retrieve.shared-components/ah-retrieve-atvo-credit-card-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.authglobal.shared-components/ah-quick-help-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/authglobal-ah-quick-help-shared-component-es6" */ "@sparta.authglobal.shared-components/ah-quick-help-shared-component/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
